import { elements, globalEvent } from '@shared/easyfy.core';
import { toggleClass, visible } from '@shared/easyfy.utils';

export default class ToggleCss {
  static Instance: ToggleCss;

  static Event: string;

  constructor(event: string) {
    ToggleCss.Instance = this;
    ToggleCss.Event = event;

    globalEvent({
      type: 'click',
      events: [
        {
          callback: e => {
            ToggleCss.Instance.hideToggle(e?.target);
          },
        },
        {
          event: ToggleCss.Event,
          callback: this.onToggleElement,
        },
      ],
    });
  }

  onToggleElement(e: any, hide: boolean) {
    if (e?.preventDefault) e.preventDefault();
    if (e.target) e = e.target;

    let target = e.attributes['data-target']?.value;

    if (!target) {
      e = e.parentNode as HTMLElement;
      target = e.attributes['data-target']?.value;
    }

    if (!target) return false;

    const el = document.querySelectorAll<HTMLElement>(`[data-container="${target}"]`);
    const toggleClassName: string = e.attributes['data-toggleClassName']?.value;

    if (!hide) {
      ToggleCss.Instance.hideToggle(e);
    }

    el.forEach((item) => {

      if (toggleClassName) {
        toggleClass(item, toggleClassName);
      }
    });

    return false;
  }

  hideToggle(target: any) {
    const toggleElements: NodeListOf<HTMLElement> = elements(`[data-event="${ToggleCss.Event}"]`);
    toggleElements.forEach((el) => {
      const dataTarget = el.attributes['data-target']?.value;

      const dataTargetElement: NodeListOf<HTMLElement> = document.querySelectorAll<any>(`[data-container="${dataTarget}"]`);
      dataTargetElement.forEach((item) => {
        if (!el.contains(target) && visible(item) && visible(el) && !item.contains(target) && el !== target) {
          this.onToggleElement(el, true);
        }
      });
    });
  }
}
